import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const getPromptKeys = () =>
    axios.get(`${apiUrl}ats/prompts`);

export const getPromptByKey = (key) =>
    axios.get(`${apiUrl}ats/prompts/${key}`);

export const updatePrompt = (key, data) =>
    axios.put(`${apiUrl}ats/prompts/${key}`, data);
